import { useEffect, useRef, useState } from 'react'
import { updateCompany } from '../../db/api.js'
import DealDevelopmentDialog from './DealDevelopmentDialog.jsx'

const demo = import.meta.env.DEV && import.meta.env.MODE === 'demo'
const digits = (value) => String(value || '').replace(/\D/g, '')
const format = (value) => digits(value).slice(0, 14)
  .replace(/^(\d{2})(\d)/, '$1.$2')
  .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
  .replace(/\.(\d{3})(\d)/, '.$1/$2')
  .replace(/(\d{4})(\d)/, '$1-$2')

export default function DealCompanyCnpj({ dealId, company, onSaved }) {
  const current = company?.cnpj || ''
  const [open, setOpen] = useState(false)
  const [updateOpen, setUpdateOpen] = useState(false)
  const [value, setValue] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const root = useRef(null)
  const trigger = useRef(null)
  const close = () => { setOpen(false); trigger.current?.focus() }

  useEffect(() => {
    if (!open) return
    const outside = (event) => { if (!busy && !root.current?.contains(event.target)) setOpen(false) }
    document.addEventListener('pointerdown', outside)
    return () => document.removeEventListener('pointerdown', outside)
  }, [open, busy])

  const save = async (event) => {
    event.preventDefault()
    if (busy) return
    setError('')
    const cnpj = digits(value)
    if (cnpj.length !== 14) { setError('Digite os 14 dígitos do CNPJ.'); return }
    setBusy(true)
    try {
      const saved = demo
        ? (await import('../../demo/data.js')).saveDemoCompanyCnpj(dealId, cnpj)
        : await updateCompany(company.id, { cnpj })
      onSaved(saved)
      close()
    } catch (err) { setError(err.message) }
    finally { setBusy(false) }
  }

  return <div className="dp-company-cnpj dp-cnpj" ref={root} onKeyDown={(event) => { if (open && event.key === 'Escape') { event.stopPropagation(); if (!busy) close() } }}>
    <span className="cv-row-label">CNPJ</span>
    <div className="dp-cnpj-value-row">
      <button type="button" ref={trigger} className="dp-origin-trigger" aria-expanded={open} onClick={() => { setOpen(!open); setValue(format(current)); setError('') }}>{current ? format(current) : 'Adicionar CNPJ'}</button>
      {current && <button type="button" className="dp-cnpj-update" onClick={() => { setOpen(false); setUpdateOpen(true) }}>Atualizar dados</button>}
    </div>
    {updateOpen && <DealDevelopmentDialog page="atualizar-empresa" onClose={() => setUpdateOpen(false)} />}
    {open && <form className="dp-cnpj-menu" onSubmit={save}>
      <label>Digite o CNPJ<input autoFocus inputMode="numeric" maxLength={18} value={value} disabled={busy} placeholder="00.000.000/0000-00" onChange={(event) => { setValue(format(event.target.value)); setError('') }} /></label>
      {error && <small role="alert">{error}</small>}
      <div className="dp-cnpj-actions"><button type="button" disabled={busy} onClick={close}>Cancelar</button><button type="submit" disabled={busy}>{busy ? 'Salvando…' : 'Salvar'}</button></div>
    </form>}
  </div>
}
